import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "dashcam"
const DashcamIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M15.75 3.75C16.993 3.75 18 4.757 18 6V8.247L21.232 6.19 21.337 6.134C21.868 5.892 22.5 6.277 22.5 6.887V17.113C22.5 17.763 21.781 18.159 21.232 17.81L18 15.752V18C18 19.243 16.993 20.25 15.75 20.25H4.5C3.257 20.25 2.25 19.243 2.25 18V6C2.25 4.757 3.257 3.75 4.5 3.75zM4.5 5.25C4.086 5.25 3.75 5.586 3.75 6V18C3.75 18.414 4.086 18.75 4.5 18.75H15.75C16.164 18.75 16.5 18.414 16.5 18V6C16.5 5.586 16.164 5.25 15.75 5.25zM18 10.025V13.973L21 15.883V8.116z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default DashcamIcon
